import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import Card from 'wonderbly-components/lib/Card';
import ProductGridMarketingCard from '../ProductGrid/ProductGridMarketingCard';
import { addMarketingCardCode } from '../ProductGrid/helpers';
import SectionHeading from '../SectionHeading';
import { useModel } from '../../hooks';
import './SublimatorProductGrid.scss';

const SublimatorProductGrid = props => {
  const { sublimatorModel } = useModel();
  if (!sublimatorModel?.products) {
    return null; 
  }

  // clone the sublmiator products to stop mutation
  const gridItems = cloneDeep(sublimatorModel.products);

  // add each marketing card, if the grid is too short push them on the end
  for (const [idx, marketingCard] of props.items.entries()) {
    // position first card always at 5
    // every following card at 11, 16, 21
    const position = idx === 0 ? 4 : (idx + 1) * 5 + 1;
    position > gridItems.length
      ? gridItems.push(marketingCard)
      : gridItems.splice(position, 0, marketingCard);
  }

  return (
    <section className="container-guttered SublimatorProductGrid">
      {props.title && (
        <SectionHeading tag="h4">
          {props.title}
        </SectionHeading>
      )}
      <div className="SublimatorProductGrid__grid">
        {gridItems.map(gridItem => {
          if (gridItem.marketingCard) {
            return (
              <div className="SublimatorProductGrid__marketing-card" 
                key={gridItem.marketingCard.main.uid}>
                <ProductGridMarketingCard
                  {...gridItem.marketingCard}
                  {...addMarketingCardCode(gridItem.marketingCard)}
                />
              </div>
            );
          }

          const {
            solidus: { sublimatorAttributes },
            prismic: { data: { productListing, productInformation } },
            prismicStringReplacements,
          } = gridItem;

          return (
            <Card
              key={sublimatorAttributes.masterSku}
              href={prismicStringReplacements.href}
              title={productInformation.title}
              image={productInformation.image.url}
              color={productListing.color}
              imageBackgroundColour={productInformation.backgroundColor}
              imageBackgroundSize={'contain'}
              badgeText={productInformation.productBadgeContent}
              badgeInline
              cta={productListing.cta}
              ageRange={prismicStringReplacements.ageRange}
              price={prismicStringReplacements.price}
            />
          );
        })}
      </div>
    </section>
  );
};


SublimatorProductGrid.propTypes = {
  title: PropTypes.string,
  items:  PropTypes.arrayOf(PropTypes.object),
};

export default SublimatorProductGrid;

